import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import LpGenerator from "../components/LpGenerator/LpGenerator";
import {executePreloads} from "./preloadRequests";

async function getLandingPageUrls(fileSlug) {
    const defaultUrls = [
        `${process.env.PUBLIC_URL}/landingPages/${fileSlug}.json`,
        `${process.env.PUBLIC_URL}/landingPages/webinars/${fileSlug}.json`,
    ];

    try {
        const response = await fetch(`${process.env.PUBLIC_URL}/landingPages/lpNames.json`);
        const contentType = response.headers.get("content-type") || "";

        if (!response.ok || !contentType.includes("application/json")) {
            return defaultUrls;
        }

        const landingPageNames = await response.json();
        const isLandingPage = Array.isArray(landingPageNames)
            && landingPageNames.includes(`${fileSlug}.json`);

        return isLandingPage
            ? [`${process.env.PUBLIC_URL}/landingPages/${fileSlug}.json`]
            : [`${process.env.PUBLIC_URL}/landingPages/webinars/${fileSlug}.json`];
    } catch (error) {
        return defaultUrls;
    }
}

export default function LPRoute({defaultSlug = "lp"}) {
    const {slug} = useParams();
    const fileSlug = slug || defaultSlug;
    const [lp, setLp] = useState(null);
    const [preloads, setPreloads] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            try {
                setErr(null);
                setLp(null);
                setPreloads(null);
                const urls = await getLandingPageUrls(fileSlug);
                let data = null;

                for (const url of urls) {
                    const resp = await fetch(url);
                    const contentType = resp.headers.get("content-type") || "";

                    if (!resp.ok || !contentType.includes("application/json")) {
                        continue;
                    }

                    data = await resp.json();
                    break;
                }

                if (!data) throw new Error(`LP not found: ${fileSlug}`);
                const preloadResults = await executePreloads(data, {
                    slug: fileSlug,
                    pageName: data.name || fileSlug,
                });

                if (!cancelled) {
                    setPreloads(preloadResults);
                    setLp(data);
                }
            } catch (e) {
                if (!cancelled) setErr(e.message);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [fileSlug]);

    if (err) return <div style={{padding: 20}}>Error: {err}</div>;
    if (!lp) return null;

    return <LpGenerator data={lp} preloads={preloads}/>;
}
